<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      width="24"
      height="24"
      rx="12"
      fill="url(#paint0_linear_2369_1754)"
    />
    <circle
      cx="8.5"
      cy="9.5"
      r="1"
      fill="#222129"
      stroke="#2E2F39"
    />
    <circle
      cx="15.5"
      cy="9.5"
      r="1"
      fill="#222129"
      stroke="#2E2F39"
    />
    <path
      d="M8 16C8 16 10.6703 14.7889 12.5 14.5C14.2359 14.226 17 14.5 17 14.5"
      stroke="#2E2F39"
      stroke-width="1.6"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2369_1754"
        x1="5.5"
        y1="3"
        x2="18.5"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE094" />
        <stop
          offset="0.59"
          stop-color="#FFA992"
        />
        <stop
          offset="1"
          stop-color="#FF667E"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
